import { Component, Input, OnInit } from "@angular/core";
import { ColorCode } from "../../Company.enum";
import { DisplayType, Roles } from 'src/app/utils'
import { EmployeeService } from 'src/app/services/employee.service';
import { ActivatedRoute } from "@angular/router";
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'app-inactive-employees',
  templateUrl: './inactive-employees.component.html',
  styleUrls: ['./inactive-employees.component.scss']
})
export class InactiveEmployeesComponent implements OnInit {

  list = [];
  employeeCount: number = 0;
  displayType = DisplayType;
  checkboxValue: boolean = false;
  isChecked = false
  selectedUsers: any[] = []

  parkId = (localStorage.getItem('parkId')) ? localStorage.getItem('parkId') : null;
  //building
  parkBuilding: any[] = []
  selectedBuidling: any[] = []
  //employee type
  selectedEmpType: any[] = []
  //right types
  selectedRights: any[] = []
  parkAdmin = 7
  dropdownFlag: boolean = true
  page = 1;
  pageSize = 50;
  totalCount = 0
  noPages = 1;
  searchText = ''
  parkTenantId: any;
  companyAdd: any;
  // list = [
  //   {
  //     checkbox: false,
  //     listId: null,
  //     details: {
  //       name: 'Divya Shrivastav',
  //       role: null,
  //       roleColor: ColorCode.ROLE_TITLE,
  //       title1: 'Creator',
  //       title2: 'Discoverer',
  //     },
  //     image:null,
  //     status: null,
  //     option: [],
  //   },
  //   {
  //     checkbox: true,
  //     listId: null,
  //     details: {
  //       name: 'surbhi',
  //       role: null,
  //       roleColor: ColorCode.ROLE_TITLE,
  //       title1: 'surbi@sharmaco.com',
  //       title2: '9183611263',
  //     },
  //     image: null,
  //     status: null,
  //     option: [

  //     ],
  //   },
  // ];

  //filter admins and coadmins from employee array

  constructor(private employeeService: EmployeeService,
    private activateRoute: ActivatedRoute,
    private rolebasedactionService: RolebasedactionService,
  ) {
    this.parkTenantId = this.activateRoute.snapshot.params.id;
    this.getBuildingsByParkId();
    // this.getEmployeeByFilter();
  }

  ngOnInit() {
    this.companyAdd = this.rolebasedactionService.checkUserRolePermissionExits('Company:Create');
    // this.filterActiveEmployee(this.list)
    this.initailFunctions();
  }

  // filterActiveEmployee(employees:any[]) {
  //   this.list = employees.filter(res => {
  //     if(!res.isActive && res.employeeRole !== Roles.ParkAdmin) {
  //       this.employeeCount++;
  //     }
  //     if(!res.isActive) {
  //       return res
  //     }
  //   });
  // }

  buildingProperty: any = ['All', ' Creator', ' Discoverer', ' Innovator'];
  empTypes: any = [{ name: 'All', image: '', checked: false }, { name: 'De-activated', image: 'assets/images/company/archive_user.png', checked: false }, { name: 'Blocked', image: 'assets/images/company/blocked_user.png', checked: false }];
  inviteRights: any = ['All', 'With Rights', 'Without Rights', 'Pending Approval'];
  buildingName: boolean;
  empType: boolean;
  employeeType: string;
  invRights: boolean;
  vmsInvite: string;
  buildingTitle: any = [];
  openOptionDrawer: boolean;
  verified: boolean = true
  nonverified: boolean = true
  withRights: boolean = true
  withOutrights: boolean = true
  pendingApproval: boolean = true
  deactive: boolean = true
  block: boolean = true
  isLoadData = false
  // page = 1;

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  enterName(field) {
    if (field == 'buildingName') {
      this.buildingName = !this.buildingName;
    }

    if (field == 'empType') {
      this.empType = !this.empType;
    }
  }
  setBuildingName(item, event = '') {
    let AllChecked;
    if (this.parkBuilding[0].checked == true) {
      console.log("isnide thiskk ");
      this.selectedBuidling = [];
      this.buildingTitle = []
      this.parkBuilding = this.parkBuilding.map(res => {
        res.checked = false;
        return res;
      })
    }
    this.buildingTitle.push(item)
    console.log(this.buildingTitle)
    if (item.parkBuildingId == 'All') {
      this.selectedBuidling = []
      AllChecked = !item.checked
      this.buildingTitle = (AllChecked) ? this.removeAll() : [];
    }
    this.parkBuilding = this.parkBuilding.map(res => {
      if (item.parkBuildingId == 'All') {
        res.checked = AllChecked;
      } else if (item.parkBuildingId == res.parkBuildingId) {
        res.checked = !res.checked;
      }
      return res;
    })
    this.getCheckedData(event);
    console.log(this.selectedBuidling);
  }

  handlePageChange(event) {
    this.page = event;
    this.getEmployeeByFilter()
  }

  getCheckedData(event = '') {
    this.selectedBuidling = []
    let resultArr = this.parkBuilding.slice(1);
    let filteredArr = resultArr.filter(res => {
      if (res.checked) {
        return res
      }
    })
    this.selectedBuidling = filteredArr.map(res => {
      return res.parkBuildingName
    });
    this.parkBuilding[0].checked = ((this.parkBuilding.length - 1) === this.selectedBuidling.length) ? true : false
    console.log(this.selectedBuidling);
    if (event == 'click') {
      this.getEmployeeByFilter()
    }
  }

  removeAll($filter = '') {
    if ($filter == 'name') {
      let resultArr = this.parkBuilding.slice(1);
      return resultArr.map(res => {
        return res.parkBuildingName
      });
    } else {
      return this.parkBuilding.slice(1);
    }
  }

  setEmpType(item, event = '') {
    console.log(item);
    let AllChecked
    if (this.empTypes[0].checked) {
      this.empTypes = this.empTypes.map(res => {
        res.checked = false
        return res
      });
    }
    // this.employeeType=item
    if (item.name == 'All') {
      AllChecked = !item.checked
    }
    this.empTypes = this.empTypes.map(res => {
      if (item.name === 'All') {
        res.checked = AllChecked;
        return res
      } else if (res.name === item.name) {
        res.checked = !res.checked
        return res;
      }
      return res
    });
    console.log(this.empTypes)
    this.getCheckedEmpTypes(event);
  }

  getCheckedEmpTypes(event = '') {
    this.selectedEmpType = []
    let resultArr = this.empTypes.slice(1);
    let filteredArr = resultArr.filter(res => {
      if (res.checked) {
        return res
      }
    })
    this.selectedEmpType = filteredArr.map(res => {
      return res.name
    });
    this.empTypes[0].checked = ((resultArr.length) === this.selectedEmpType.length) ? true : false
    console.log(this.selectedEmpType);
    if (event == 'click') {
      this.getEmployeeByFilter()
    }

  }

  checkSelectedUserIfAdmin() {
    let check = false;
    this.selectedUsers.forEach((res, i) => {
      console.log(res);
      this.list.forEach(element => {
        if (element.userId == res && element.employeeRole !== Roles.ParkAdmin) {
          this.dropdownFlag = false;
          check = true;
        }
      });
      if (i == (this.selectedUsers.length - 1) && !check) {
        this.dropdownFlag = true;
      }
    });
  }

  selectDeselectUsers() {
    this.isChecked = !this.isChecked
    this.checkboxValue = this.isChecked
    this.selectedUsers = [];
    if (this.isChecked) {
      this.list.filter(res => {
        if (res.employeeRole != Roles.ParkAdmin) {
          this.selectedUsers.push(res.userId);
        }
      });
    }
    console.log(this.selectedUsers);
    this.checkSelectedUserIfAdmin();
  }

  getSelectedUser(event) {
    console.log(event);
    console.log(this.employeeCount);
    if (event.checked) {
      this.selectedUsers.push(event.id);
    } else {
      var index = this.selectedUsers.indexOf(event.id);
      this.selectedUsers.splice(index, 1);
    }
    this.isChecked = (this.employeeCount == this.selectedUsers.length) ? true : false
    console.log(this.selectedUsers);
    this.checkSelectedUserIfAdmin();
  }

  getBuildingsByParkId() {
    this.employeeService.getBuildingByParkIdAndTenatID(this.parkId, this.parkTenantId).subscribe(res => {
      this.parkBuilding = res.list.map(res => {
        res.checked = false
        return res
      });
      this.parkBuilding.unshift({ parkBuildingName: 'All', parkBuildingId: 'All', checked: false });
      this.setBuildingName({ parkBuildingName: 'All', parkBuildingId: 'All', checked: false });
      this.getEmployeeByFilter();
    });
  }

  /// new api to be provided
  markAsAdmin($event = undefined) {
    console.log($event);
    let payload = {}
    if ($event !== undefined) {
      payload = {
        useridList: [$event.id],
        roleId: this.parkAdmin
      }
    } else {
      payload = {
        useridList: this.selectedUsers,
        roleId: this.parkAdmin
      }
    }
    this.employeeService.markAsAdmin(payload).subscribe(res => {
      console.log(res);
      this.getEmployeeByFilter();

    });
  }

  getEmployeeByFilter() {
    let payload = {
      "parkTenantId": this.parkTenantId,
      "buildingName": this.selectedBuidling,
      // "deactive": this.deactive,
      "deactive": (this.empTypes[1].checked) ? true : false,
      "block": (this.empTypes[2].checked) ? true : false,
      "pageNo": this.page,
      "size": this.pageSize,
      "searchTerm": this.searchText,
      "parkId": this.parkId,
      "actionUserCategory": "ActiveDeactive"
      // "deactive": true
    }
    this.employeeService.getEmployeeListByFilter(payload).subscribe(res => {
      console.log(res);
      if (res.isValid) {
        this.isLoadData = true
        this.totalCount = res.data.count;
        this.noPages = Math.ceil(this.totalCount / this.pageSize);
        this.list = res.data.employees
      } else {
        this.isLoadData = true
      }

      // this.filterActiveEmployee(res.data.employees);
    });

  }

  initailFunctions() {
    this.setEmpType({ name: 'All', image: '', checked: false });
  }

  changeEmpStatus(event) {
    let payload = [event.item.userId]
    if (event.type == 'revoke') {
      let body = {
        useridList: payload,
        isVMSAccess: false
      }
      this.employeeService.giveEmployeeVMSInvitationRights(body).subscribe(res => {

      });
    } else {
      this.employeeService.approveVmsRights(payload).subscribe(res => {
        console.log(res);
        this.getEmployeeByFilter();

      })
    }
  }



}

